<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="19.8086" y="10" width="13.2999" height="2" transform="rotate(135 19.8086 10)" fill="white"/>
    <rect x="10.4023" y="19.4043" width="13.2999" height="2" transform="rotate(-135 10.4023 19.4043)" fill="white"/>
  </svg>
</template>